import { GENDER, VALID_LANGUAGES } from "./caller-tune.utils";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type CallerTuneState = Readonly<{
  step: number;
  language: VALID_LANGUAGES;
  gender: GENDER;
  message: string;
  toggleEnableSave: boolean;
  copyCallerTuneModal: boolean;
}>;

export const initialState: CallerTuneState = {
  step: 1,
  language: "english",
  gender: "female",
  message: "",
  toggleEnableSave: false,
  copyCallerTuneModal: false,
};

export const callerTuneSlice = createSlice({
  name: "caller-tune",
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    setLanguage: (state, action: PayloadAction<VALID_LANGUAGES>) => {
      state.language = action.payload;
    },
    setGender: (state, action: PayloadAction<GENDER>) => {
      state.gender = action.payload;
    },
    setMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    toggleEnableSave: (state, action: PayloadAction<boolean>) => {
      state.toggleEnableSave = action.payload;
    },
    toggleCopyCallerTuneModal: (state, action: PayloadAction<boolean>) => {
      state.copyCallerTuneModal = action.payload;
    },
  },
});

export const {
  setStep,
  setLanguage,
  setGender,
  setMessage,
  toggleEnableSave,
  toggleCopyCallerTuneModal,
} = callerTuneSlice.actions;

export const callerTuneReducer = callerTuneSlice.reducer;
